(ns app.front.view.workspace.package
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui.select :as ui-select]
            [app.front.view.workspace.subs :as ws-subs]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::package-templates-raw
  :<- [::ws-subs/authority-group-id]
  (fn [auth-group-id _]
    (<sub [::entities/entities {:domain/authority-group auth-group-id
                                :entity/type            :entity.type/package-pdf-template}])))

(rf/reg-sub ::package-templates
  :<- [::package-templates-raw]
  :<- [::ws-subs/authority-group]
  (fn [[templates ag] _]
    (->> templates
         (remove (du/in-state-fn :package-pdf-template.state/disabled))
         (concat (->> (:group/enabled-inherited-templates ag)
                      (filter #(-> % :entity/type #{:entity.type/package-pdf-template}))))
         (map (fn [template]
                {:text (:package-pdf-template/name template)
                 :id   (:db/id template)})))))


(defn create-package-modal [{:keys [tr on-change parameters]}]
  (let [package-templates (<sub [::package-templates])
        selected-template (->> package-templates
                               (filter #(= (:id %) (:template-id parameters)))
                               first)]
    [:div
     [ui-select/select {:id           "package-template-select"
                        :required     true
                        :values       package-templates
                        :value        selected-template
                        :select-text  (tr [:admin-package/select-template])
                        :allow-empty? false
                        :val->str     :text
                        :on-change    #(on-change {:template-id (:id %)})}]]))


(defn parameters-valid? [props]
  (some? (:template-id props)))
